import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {withBoundary} from 'Components/ErrorBoundary'
import DocumentTitle from 'react-document-title'
import {Redirect} from 'react-router-dom'
import {Spin, Button, Divider} from 'antd'

import style from './confirmEmail.sass'

@withBoundary
@inject('store') @observer
class ConfirmEmail extends Component {
  componentDidMount() {
    const validation_key = new URLSearchParams(document.location.search).get('validation_key')
    this.props.store.user.resetEmailConfirmationStatus()
    if (validation_key) {
      this.props.store.user.confirmEmail(validation_key)
    }
  }
  resendConfirmation = () => {
    this.props.store.user.resendConfirmation()
  }
  render() {
    const {emailVerificationFailed, emailResent, data} = this.props.store.user
    const {is_email_verified, email, is_staff} = data
    const validation_key = new URLSearchParams(document.location.search).get('validation_key')

    if (is_email_verified && !is_staff) {
      return <Redirect to='/'/>
    }

    return(
      <div className='card' styleName='container'>
        <DocumentTitle title='Confirm Email'/>
        <img src='/img/logo-color.png'/>
        <Divider/>
        {emailResent
          ? <div>
            <h2>Email resent</h2>
            <h3>{email}</h3>
            <p>
              We have sent you an email for verification purposes.
              Please check your spam folder if you don&apos;t see it in your inbox.
              Contact us at <a href='mailto:support@algoriz.com'>support@algoriz.com</a> if you have any questions.
            </p>
            <Button type='primary' onClick={this.resendConfirmation}>Try again</Button>
          </div>
          : !validation_key
            ? <div>
              <h2>Verify your email address</h2>
              <h3>{email}</h3>
              <p>
              We have sent you an email for verification purposes.
              Please check your spam folder if you don&apos;t see it in your inbox.
              Contact us at <a href='mailto:support@algoriz.com'>support@algoriz.com</a> if you have any questions.
              </p>
              <Button type='primary' onClick={this.resendConfirmation}>Resend</Button>
            </div>
            : emailVerificationFailed
              ? <div>
                <h3>Could not verify your email</h3>
                <Button type='primary' onClick={this.resendConfirmation}>Resend</Button>
              </div>
              : <div>
                <Spin size='large'>
                  <div style={{height: '200px'}}/>
                </Spin>
              </div>
        }
      </div>
    )
  }
}

export default ConfirmEmail
